<template >
  <div class="legend-box" v-click-outside="() => showDropdown = false">

    <!-- Dropdown with caret if item has options -->
    <div v-if="item.options" class="legend-options">
      <div class="legend-item__button" :class="itemGroupActive(item)" :style="colorPicker(item).style">
        <a class="legend-item__button__label" @click="toggleDropdown">{{ item.name }} &#9662;</a>
      </div>
      <div v-show="showDropdown" class="legend-dropdown">
        <ul>
          <li
            v-for="(opt, index) in item.options"
            :key="`dropdown-${index}-index`"
            class="legend-dropdown__item legend-tooltip"
            >
            <span v-if="opt.hoverText" class="legend-tooltip__text">{{ opt.hoverText }}</span>
            <vp-checkbox
              v-model="opt.isActive"
              class="checkbox-label"
              @input="checkboxUpdated(opt)"
            >
              <template #label>{{ opt.name }}</template>
            </vp-checkbox>
          </li>
          <li v-show="item.removable">
            <vp-button @click="removeItem(item)">{{ removeButtonLabel }}</vp-button>
          </li>
        </ul>
      </div>
    </div>

    <!-- Button without caret for no options -->
    <div v-if="!item.options" class="legend-item__button legend-tooltip" :style="colorPicker(item).style"  :class="[item.isActive ? 'active' : 'inactive']">
      <a @click="optionUpdated(item)"> {{ item.name }}</a>
      <span v-if="item.hoverText" class="legend-tooltip__text">{{ item.hoverText }}</span>
    </div>

  </div>
</template>

<script>
import { clickOutside } from '../../../utilities/directives';

export default {
  name: 'VpChartLegendDropdown',
  directives: {
    clickOutside,
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    removeButtonLabel: {
      type: String,
      default: 'Remove',
    },
  },
  data() {
    return {
      showDropdown: false,
    };
  },
  methods: {
    checkboxUpdated(option) {
      return this.$emit('selection-updated', option);
    },
    colorPicker(item) {
      const output = {
        style: {},
      };
      output.style = {
        'background-color': item.backgroundColor,
        color: item.fontColor,
        border: item.border,
        'border-radius': item.borderRadius,
      };
      return output;
    },
    itemGroupActive(item) {
      const activeIndex = item.options.findIndex(el => el.isActive);
      if (activeIndex !== -1) {
        return 'active';
      } else {
        return 'inactive';
      }
    },
    optionUpdated(item) {
      item.isActive = !item.isActive;
      return this.$emit('selection-updated', item);
    },
    removeItem(item) {
      return this.$emit('remove-item', item);
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../src/styles/colors.scss";

.legend-box {
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-transition: height 0.5s ease-in-out;
  -moz-transition: height 0.5s ease-in-out;
  -o-transition: height 0.5s ease-in-out;
  transition: height 0.5s ease-in-out;
}

.legend-item__button {
    height: 25px;
    background-color: #0B7DB7;
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    padding: 5px 8px;
    font-size: 14px;
    line-height: 14px;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
    &.inactive {
    background-color: #fff !important;
    border: solid 1px #DBDBDB;
    user-select:none;

    .legend__item-point {
      &::before {
        background-color: var(--color) !important;
      }
      .circle,
      .rect,
      .triangle,
      .cross,
      .crossRot,
      .star {
        color: var(--color);
      }
      &.area {
        margin: 0 20px 0 10px;
        background-color: var(--color);
      }
    }
    a {
      color: #4F4F4F !important;
      font-weight: normal;
      user-select: none;
    }
  }
}
.legend-item__button__label {
 user-select: none;
}

.legend-options {
  display: inline-block;
  position: relative;
}

.legend-dropdown {
    display: flex;
    width: 200px;
    position: absolute;
    background: #FFFFFF;
    border: 1px solid #DBDBDB;
    box-sizing: border-box;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    z-index: 1000;
}

ul {
    display: inline-block;
    margin: 0;
    padding: 0;
    border-radius: 6px;
}

li {
    border-top: 1px solid #DBDBDB;
    margin: 0;
    list-style-type: none;
    padding: 5px;
}

li.legend-dropdown__item {
    font-size: 16px;
    color: #016699;
    margin: 2px 0;
}
.checkbox-label {
  font-size: smaller;
}
.legend-tooltip {
  position: relative;
  justify-content: center;
}
.legend-tooltip {
  .legend-tooltip__text {
    visibility: hidden;
    width: 250px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1001;
    left: 10%;
    top: 125%;
    opacity: 0;
    transition: opacity 0.3s;
  }
}

.legend-tooltip:hover .legend-tooltip__text {
  margin-top: 5px;
  visibility: visible;
  opacity: 1;
  transition-delay: 1s;
  white-space: normal;
  line-height: 1.5em;
  font-size: 16px;
}

@media (max-width: 1200px) {
  .legend-tooltip .legend-tooltip__text {
    font-size: 14px;
    max-width: fit-content;
  }
}
</style>
